import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'

// Import supabase client from utils
import { supabase } from './utils/supabaseClient'

// Export supabase for use in other files
export { supabase }

// Create Vue application
const app = createApp(App)

// Use plugins
app.use(store)
app.use(router)

// Mount app
app.mount('#app')